<!-- BaseSelect.vue (admin) -->
<template tag="관리자 선택 컴포넌트">
  <component
    :is="isAuto ? 'v-autocomplete' : 'v-select'"
    v-model="selectedValue"
    :items="options ?? []"
    item-title="label"
    item-value="value"
    density="compact"
    variant="outlined"
    :class="className"
    :placeholder="placeholder || $text('common.all')"
    :disabled="disabled"
    :no-data-text="$text('message.noData')"
    :error-messages="errorMessages"
    autocomplete="off"
  ></component>
</template>

<script setup lang="ts">
import { defineProps, type PropType, onMounted } from "vue";

/* ------------------------------------------------------------
                          Vue Instance & Global Properties
   ------------------------------------------------------------ */
import { i18n } from "@/app/plugins/global";
const { $text } = i18n();

/* ------------------------------------------------------------
                          Model
   ------------------------------------------------------------ */
const selectedValue = defineModel<string | number | null>();

/* ------------------------------------------------------------
                          Props
   ------------------------------------------------------------ */
const props = defineProps({
  placeholder: { type: String, default: "" },
  options: {
    type: Array as PropType<{ label: string; value: string }[]>,
    default: () => [],
  },
  disabled: { type: Boolean, default: false },
  errorMessages: { type: Array as PropType<string[]>, default: () => [] },
  isAuto: { type: Boolean, default: true }, // 자동완성 여부 ( admin 모드에서는 기본값 true )
  className: { type: String, default: "" },
});

/* ------------------------------------------------------------
                          Methods
   ------------------------------------------------------------ */
/** 기본값 설정 */
function getDefaultValue() {
  return props.placeholder ? null : (props.options[0]?.value ?? null);
}

/* ------------------------------------------------------------
                          Lifecycle
   ------------------------------------------------------------ */
onMounted(() => {
  if (selectedValue.value === null || selectedValue.value === undefined) {
    selectedValue.value = getDefaultValue();
  }
});
</script>
